import PresentationMetadata from './PresentationMetadata';

export default [() => {
    return PresentationMetadata.createPresentationMetadata();
}];